<template>
	<view-component
	v-if="view == 'tipos-de-pedido'"
	model_name="order_type"></view-component>
</template>
<script>
export default {
	components: {
		ViewComponent: () => import('@/common-vue/components/view/Index')
	}
}
</script>